var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.844 14.518l-4.246-4.213.263-.354.007-.009c.047-.061.094-.125.138-.188l.004-.006c1.664-2.36 1.295-5.697-.903-7.867A6.51 6.51 0 0 0 6.505 0a6.502 6.502 0 0 0-4.6 1.882A6.337 6.337 0 0 0 0 6.424c0 1.716.677 3.328 1.905 4.541a6.49 6.49 0 0 0 4.59 1.877 6.61 6.61 0 0 0 3.002-.722c.103-.057.413-.234.66-.432l4.312 4.159a.547.547 0 0 0 .367.153.498.498 0 0 0 .35-.149l.215-.205c.164-.157.337-.321.46-.443.24-.238.124-.538-.017-.685M6.476 1.728c2.619 0 4.75 2.104 4.75 4.69 0 2.586-2.131 4.69-4.75 4.69s-4.751-2.104-4.751-4.69c0-2.586 2.132-4.69 4.75-4.69"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.8585e42771bc863bbaaf1356f6240ff0.svg";